import { useSelector } from "react-redux";
import { createSlice, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import SimManager from "../managers/simManager";

import { SET_MODAL } from "./actions";

export { SET_MODAL, CLOSED_SIM_MODAL, ITEM_DRAGGED } from "./actions";
export const CreateSimSlice = <T>(
  initialState: T,
  reducers: (builder: ActionReducerMapBuilder<T>) => void
) =>
  createSlice({
    name: "Simulation",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(SET_MODAL, (_, action) => {
        if (action.payload?.data && action.payload.data.name) {
          SimManager.getInstance().openModal(
            action.payload.data.name,
            "",
            action.payload.data
          );
          SimManager.getInstance().setInputValue("sim_state", {
            viewingModal: action.payload.data.name,
          });
        }
      });
      reducers(builder);
    },
  });

export const useSimulation = <T = unknown>() =>
  useSelector((state: { simulation: T }) => state.simulation);
